import { render, staticRenderFns } from "./SafeForWorkStatusSettings.vue?vue&type=template&id=d1ae29a0&scoped=true&"
import script from "./SafeForWorkStatusSettings.vue?vue&type=script&lang=ts&"
export * from "./SafeForWorkStatusSettings.vue?vue&type=script&lang=ts&"
import style0 from "./SafeForWorkStatusSettings.vue?vue&type=style&index=0&id=d1ae29a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1ae29a0",
  null
  
)

export default component.exports